import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import OrderActions from '~redux/Order/actions';
import { ORDER_STATUS } from '~constants/orders';
import { useUnsavedChanges } from '~hooks/useUnsavedChanges';

import UserPermissions from '../UserPermissions';
import ConfirmNavigationModal from '../ConfirmNavigationModal';

import SideBarItem from './components/SideBarItem';
import { getSidebarItemsFromState } from './constants';
import { getQuantityByStatus } from './utils';
import styles from './styles.module.scss';

function SideBar() {
  const dispatch = useDispatch();
  const { userActions, userPolicies } = useSelector((state) => state.adminUser);
  const state = useSelector((state) => state); // Obtener el estado completo
  const sidebarItems = getSidebarItemsFromState(state);
  const sideBarItems = Object.keys(sidebarItems).map((itemName) => ({
    ...sidebarItems[itemName],
    name: itemName
  }));

  const sortedSideBarItems = [...sideBarItems].sort((itemA, itemB) => itemA.order - itemB.order);
  const { activeTab } = useSelector((state) => state.order);
  const { ordersLoading, quantityOrders } = useSelector((state) => state.order);
  const [itemSelected, setItemSelected] = useState(activeTab);
  const { storeSelected } = useSelector((state) => state.core);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const { hasUnsavedChanges } = useUnsavedChanges();

  useEffect(() => {
    setItemSelected(activeTab);
  }, [activeTab]);

  const handleSideBarClick = (item) => {
    if (activeTab === 'ORDER_TAKER' && hasUnsavedChanges()) {
      setPendingNavigation(item);
      setShowConfirmModal(true);
      return;
    }
    performNavigation(item);
  };

  const performNavigation = (item) => {
    setItemSelected(item);
    dispatch(OrderActions.setActiveTab(item));
    dispatch(OrderActions.setOrdersFilter(sidebarItems[item].status));
    if (
      !sidebarItems[item].status.includes(ORDER_STATUS.PRODUCTS) &&
      !sidebarItems[item].status.includes(ORDER_STATUS.REJECTED_ORDER_MANAGER)
    ) {
      dispatch(OrderActions.getOrders(storeSelected, sidebarItems[item].status, 1));
    }
  };

  const handleConfirmNavigation = () => {
    if (pendingNavigation) {
      performNavigation(pendingNavigation);
    }
    setShowConfirmModal(false);
    setPendingNavigation(null);
  };

  const handleCancelNavigation = () => {
    setShowConfirmModal(false);
    setPendingNavigation(null);
  };

  return (
    <>
      <div className={cn('column', styles.sideBarContainer)}>
        {sortedSideBarItems.map(
          ({ status, policy, name, actions, showQuantityOrders }) =>
            !!(userActions && userPolicies) && (
              <UserPermissions key={status} policy={policy} actions={actions}>
                <SideBarItem
                  onClick={handleSideBarClick}
                  isSelected={itemSelected === name}
                  item={name}
                  disabled={ordersLoading}
                  quantity={showQuantityOrders ? getQuantityByStatus(status, quantityOrders) : 0}
                  showQuantity={showQuantityOrders}
                  sidebarItem={sidebarItems[name]}
                />
              </UserPermissions>
            )
        )}
      </div>

      <ConfirmNavigationModal
        isOpen={showConfirmModal}
        onConfirm={handleConfirmNavigation}
        onCancel={handleCancelNavigation}
        title="¿Salir del tomador de pedidos?"
        message="Se perderán los datos del pedido. ¿Estás seguro de que quieres continuar?"
      />
    </>
  );
}

export default SideBar;
